import type {ProjectJobSummary} from 'src/projects/schemas'

function isPickupJob(job: ProjectJobSummary): boolean {
    return job.isPickup === true || job.scheduleRole === 'pickup'
}

function isServiceVisitJob(job: ProjectJobSummary): boolean {
    return job.scheduleRole === 'service'
}

/**
 * Newest non-cancelled job that is not a pickup or service visit, falling back to the newest
 * service visit, pickup or job. Sorted by creation time, then display id.
 */
export function pickAddJobSource(jobs: ProjectJobSummary[]): ProjectJobSummary | null {
    const newestFirst = [...jobs].sort(
        (left, right) =>
            (right.createdAt?.getTime() ?? 0) - (left.createdAt?.getTime() ?? 0) ||
            right.displayId.localeCompare(left.displayId),
    )
    const live = newestFirst.filter((job) => job.status !== 'cancelled')
    return (
        live.find((job) => !isPickupJob(job) && !isServiceVisitJob(job)) ??
        live.find((job) => !isPickupJob(job)) ??
        live[0] ??
        newestFirst[0] ??
        null
    )
}
